import { LOCALE_COOKIE_NAME, type Locale, isLocale } from '@/lib/i18n/config'
import type { DocsLocale } from '@/lib/docs-i18n'

/** Base path for docs in the given locale (`/docs` or `/docs/de`). */
export function getDocsBasePath(locale: DocsLocale): string {
  return locale === 'de' ? '/docs/de' : '/docs'
}

/** Full docs URL for a slug path, e.g. `getDocsUrl('en', ['install', 'hardware'])`. */
export function getDocsUrl(locale: DocsLocale, slug?: string[]): string {
  const base = getDocsBasePath(locale)
  if (!slug?.length) return base
  return `${base}/${slug.join('/')}`
}

/** Persist dashboard locale cookie (same contract as LocaleProvider.setLocale). */
export function setLocaleCookie(locale: Locale): void {
  if (typeof document === 'undefined') return
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie = `${LOCALE_COOKIE_NAME}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${secure}`
  try {
    localStorage.setItem(LOCALE_COOKIE_NAME, locale)
  } catch {
    /* ignore */
  }
}

export function cookieLocaleToDocsLocale(value: string | undefined): DocsLocale {
  return isLocale(value) && value === 'de' ? 'de' : 'en'
}
